import PropTypes from 'prop-types';

function MMHomeActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M2.42485 11.3531C2.13181 14.3794 1.83345 22.723 2.42485 24.9661C2.58469 25.5629 27.1893 26.0317 27.1627 24.9661C26.9762 17.2778 27.1627 8.7584 27.1627 8.7584C27.1627 8.7584 2.12116 6.80302 2.1478 8.2256C2.17444 9.64817 2.42485 11.3531 2.42485 11.3531Z"
                fill="#F2EBD1"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.98708 7.71924C8.00546 8.19006 7.9286 8.65976 7.76109 9.10016C7.59359 9.54057 7.3389 9.94263 7.01229 10.2822C6.68567 10.6219 6.29385 10.892 5.86032 11.0766C5.42678 11.2611 4.96044 11.3563 4.48926 11.3563C4.01807 11.3563 3.55174 11.2611 3.1182 11.0766C2.68466 10.892 2.29284 10.6219 1.96623 10.2822C1.63961 9.94263 1.38492 9.54057 1.21742 9.10016C1.04992 8.65976 0.973054 8.19006 0.991434 7.71924H7.98708Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.105 7.71924C15.1234 8.19006 15.0465 8.65976 14.879 9.10016C14.7115 9.54057 14.4568 9.94263 14.1302 10.2822C13.8036 10.6219 13.4118 10.892 12.9782 11.0766C12.5447 11.2611 12.0784 11.3563 11.6072 11.3563C11.136 11.3563 10.6697 11.2611 10.2361 11.0766C9.80258 10.892 9.41076 10.6219 9.08415 10.2822C8.75753 9.94263 8.50284 9.54057 8.33534 9.10016C8.16784 8.65976 8.09097 8.19006 8.10935 7.71924H15.105Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.1062 7.71924C22.1062 8.64763 21.7374 9.53799 21.0809 10.1945C20.4245 10.8509 19.5341 11.2197 18.6057 11.2197C17.6773 11.2197 16.787 10.8509 16.1305 10.1945C15.474 9.53799 15.1052 8.64763 15.1052 7.71924H22.1062Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.0112 7.84717C29.0112 8.77555 28.6424 9.66592 27.986 10.3224C27.3295 10.9789 26.4391 11.3477 25.5107 11.3477C24.5824 11.3477 23.692 10.9789 23.0355 10.3224C22.3791 9.66592 22.0103 8.77555 22.0103 7.84717H29.0112Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.02456 0.398682C3.77248 0.760985 0.490444 7.7886 1.05521 7.78327C4.51307 7.7513 29.219 8.76362 28.9952 7.78327C28.6435 6.22217 26.816 0.93148 25.0258 0.750329C23.2356 0.569177 5.02456 0.398682 5.02456 0.398682Z"
                fill="#DFA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.87885 25.4135L12.7396 25.5787C12.7396 25.5787 12.8089 17.2883 12.7396 16.2973C12.5851 13.9477 7.78461 13.3562 7.0973 16.0416C6.8309 18.924 6.87885 25.4135 6.87885 25.4135Z"
                fill="#DC6C31"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M23.0279 15.3863C22.6389 15.3863 17.1671 14.9334 16.8474 15.3171C16.5277 15.7007 16.1654 19.9418 16.8474 20.1762C17.5294 20.4106 23.0705 20.8155 23.3262 20.1762C23.582 19.5368 24.1734 15.4449 23.0279 15.3863Z"
                fill="#DC6C31"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path d="M8.01367 8.15623L10.8961 0.398682" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M15.1052 8.46538L15.4142 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M22.0103 8.52399L20.0869 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
        </svg>
    );
}

export default MMHomeActive;

MMHomeActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMHomeActive.defaultProps = {
    className: null,
    width: 28,
};
